module.exports = __webpack_public_path__ + "img/1.c4a020ae.png";